document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".product__essentials-carousel")
  const prevButton = document.getElementById("prev-button")
  const nextButton = document.getElementById("next-button")
  const images = carousel.querySelectorAll("img")
  const videos = carousel.querySelectorAll("deferred-media")
  const footerItems = document.querySelectorAll(".product__essentials-carousel-footer__image")

  const zoomImage = document.getElementsByClassName("currentSlide")

  let currentIndex = 0
  let startX = 0
  let endX = 0

  carousel.addEventListener("touchstart", function (e) {
    if (window.innerWidth > 768) return // Only on mobile
    if (e.touches.length > 1) return // Ignore if more than one finger (pinch)
    startX = e.touches[0].clientX
  })

  carousel.addEventListener("touchmove", function (e) {
    if (window.innerWidth > 768) return // Only on mobile
    if (e.touches.length > 1) return // Ignore if more than one finger (pinch)
    endX = e.touches[0].clientX
  })

  carousel.addEventListener("touchend", function (e) {
    if (window.innerWidth > 768) return
    if (e.changedTouches.length > 1) return

    // Si la imagen actual está en modo zoom, no hacer swipe
    const currentImg = images[currentIndex]
    if (currentImg.classList.contains("enlarged")) return

    if (startX && endX) {
      if (startX - endX > 50) {
        nextImage()
      } else if (endX - startX > 50) {
        prevImage()
      }
    }
    // Reinicia los valores para evitar falsos positivos
    startX = 0
    endX = 0
  })

  function showImage(index) {
    images.forEach(function (image) {
      image.style.display = "none"
    })
    images[index].style.display = "block"

    videos.forEach(function (video) {
      video.style.display = "none"
    })
    if (videos[index]) videos[index].style.display = "block"

    // Indicador de drag
    const bar = document.querySelector(".carousel-drag-indicator-bar")
    if (bar) {
      const total = images.length
      const barWidth = 100 / total
      bar.style.width = barWidth + "%"
      bar.style.left = barWidth * index + "%"
    }
  }

  function prevImage() {
    currentIndex = (currentIndex - 1 + images.length) % images.length
    showImage(currentIndex)
  }

  function nextImage() {
    currentIndex = (currentIndex + 1) % images.length
    showImage(currentIndex)
  }

  function changeImage(event) {
    const index = event.target.getAttribute("data-change")
    if (!isNaN(index)) {
      currentIndex = index
      showImage(currentIndex)
    }
  }

  prevButton.addEventListener("click", prevImage)
  nextButton.addEventListener("click", nextImage)

  footerItems.forEach(function (item) {
    item.addEventListener("click", changeImage)
  })

  for (let i = 0; i < zoomImage.length; i++) {
    zoomImage[i].addEventListener("click", function () {
      this.classList.toggle("enlarged")
    })
  }

  showImage(currentIndex)
})
